module.exports = __webpack_public_path__ + "static/media/GlacialIndifference-Regular.13dc531a.otf";